window.Vue = require('vue');

require('./tokens');
require('./directives');
require('./filters');
require('./components/bootstrap');
require('./components/common/navigation-and-search.js');
require('./vanilla-fitvids');
require('./gift');

import store from './store';
import {VBToggle, BButton, BDropdown, BDropdownItem, BCollapse, BCarousel, BCarouselSlide, BImgLazy} from 'bootstrap-vue';
import hydrateCart from './mixins/cart/hydratecart';
import {Validator} from 'vee-validate';
import VeeValidate from 'vee-validate';
import VueEvents from 'vue-events';
import VueCookies from 'vue-cookies'
import App from './font-awesome-picker/App';
import swal from 'sweetalert2'

Vue.directive('b-toggle', VBToggle);
Vue.component('b-button', BButton);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-item', BDropdownItem);
Vue.component('b-collapse', BCollapse);
Vue.component('b-carousel', BCarousel);
Vue.component('b-carousel-slide', BCarouselSlide);
Vue.component('b-img-lazy', BImgLazy);

Vue.use(VueCookies);
Vue.use(VueEvents);
Vue.use(VeeValidate);
VueCookies.config('7d'); // Set default config

//----------------------------------------------------------------------------
//  Preconfigured sweetalert
//----------------------------------------------------------------------------

window.toast = swal.mixin({
    toast: true,
    timer: 3000,
    position: 'top-right',
    showConfirmButton: false,
    customClass: 'toast-alert',
    onOpen: toggleLivechat,
    onClose: toggleLivechat
});

var livechat = true;

function toggleLivechat() {

    if (window.LivechatWidget) {
        if (livechat) {
            // Hides live chat icon button
            window.LiveChatWidget.call('hide');
        } else {
            // Shows live chat icon button
            window.LiveChatWidget.call('minimize')
        }

        livechat = !livechat;
    }
}


window.dataLayer = window.dataLayer || [];
if (window.User.guest) {
    window.dataLayer.push({
        'LoginStatus': 'Logged Out'
    });
} else {
    let data = {
        'LoginStatus': 'Logged In',
        'UserId': window.User.hasOwnProperty('id') ? window.User.id.toString() : ''
    };

    if (window.Subscription.allowedToStream) {
        data['MemberStatus'] = 'Subscribed';
        data['MemberType'] = window.Subscription.subscription.membership.name;
    } else {
        data['MemberStatus'] = 'Not Subscribed';
    }

    window.dataLayer.push(data);
}

//----------------------------------------------------------------------------
//  Vee-validate extension
//----------------------------------------------------------------------------

Validator.extend('after_now', {
    getMessage: field => 'Your expiry date needs to be after today\'s date.',
    validate: value => {
        return dayjs(value, 'MM/YY').add(1, 'months') > dayjs();
    }
});

window.Bus = new Vue();
// import Subscription from './services/routes/user/subscription';

const app = new Vue({
    el: '#spark-app',
    data: {
        csrf: window.csrfToken,
    },
    store,
    created() {
        this.$store.commit('user/updateUser', window.User);

        if (window.Subscription) {
            this.$store.commit('subscription/updateSubscription', window.Subscription);
        }
    },
    mounted() {
        document.addEventListener('clickedOutsideNavigationDropdowns', e => {
            this.$root.$emit('bv::toggle::collapse', e.detail);
        });
    },
    mixins: [
        hydrateCart
    ],
    components: {
        'App': App,
    },
});

//----------------------------------------------------------------------------
//  Recaptcha
//----------------------------------------------------------------------------

if (!window.disableGlobalRecaptcha && typeof grecaptcha !== 'undefined') {
    document.querySelectorAll('form .recaptchaResponse').forEach(recaptchaResponseInput => {
        const form = recaptchaResponseInput.closest('form');

        if (!form) {
            return;
        }

        form.addEventListener('submit', e => {
            e.preventDefault();

            grecaptcha.ready(() => {
                grecaptcha.execute(process.env.MIX_RECAPTCHA_SITE_KEY, {action: 'submit'}).then(token => {
                    recaptchaResponseInput.value = token;
                    form.submit();
                });
            });
        });
    });
}
